// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de la disposición del tragamonedas
 * @param {*} scene 
 */
export function cargaAssetsMensajesPanel(scene) {
  scene.load.image(
    "mensajePanelPagarSeguro",
    ROUTES.rutaBlackJackMensajesPanel + "/mensajePanel1PagarSeguroResized.png"
  );

}
